// 14-B4 paid its App.tsx lines in R37/R42's currency: **MOVE THE DATA, NOT THE COMPONENT.**
//
// These are the rotating status lines a member reads while her numerology is being written — the
// only thing on the screen for the length of a real generation. They were three arrays typed inside
// `run()`, inside a component that holds a dozen hooks, so no gate could ever load them: every check
// that could have been written about them would have been a regex over a 13,000-line file.
//
// Out here they are DATA with a resolver, and the resolver is the point (R31/R44: a silent fallback
// is how a roster and its caller drift apart). `numerologyStages` answers the general set for a focus
// nobody rostered, which is correct — a new focus must not leave her staring at a blank status line —
// and because the fallback is a NAMED function rather than an inline `||`, a gate can ask it what it
// does with an unknown focus instead of inferring it.
//
// It imports NOTHING, which is the entry requirement that lets a `.mjs` gate load and RUN it.
//
// **R211 — AND THAT ENTRY REQUIREMENT IS WHY THESE ARE CATALOG KEYS RATHER THAN SENTENCES.** 14-B4
// moved the data out and left it as raw ENGLISH, so this room's rotating lines were the only thing
// on a Spanish member's screen for the length of a real generation and they were in English — and
// **six of the eleven were byte-identical second copies of rows already sitting in `src/strings.js`
// in BOTH languages** (R28/R29: the Spanish was written, shipped and read by other surfaces while
// this room showed the English). Resolving `t` in here would import the catalog and cost the module
// the property this comment is about, so the KEYS live here and the CALLER resolves them — which is
// the shape every one of the other nineteen stage blocks in this house already has, and is what
// puts these lines inside S1-A/R117's census for the first time.

export const NUMEROLOGY_STAGES: Record<string, string[]> = {
  full: [
    "num.coreNumbers",
    "num.lifePathExpression",
    "num.soulPersonality",
    "num.writingFull",
  ],
  compatibility: [
    "num.bothNumbers",
    "num.comparingPaths",
    "num.harmonise",
    "num.writingCompat",
  ],
};

// The set for a focus this house has not written stages for. Never empty: an empty list would leave
// `stages[0]` undefined and put `undefined` on her screen as the status.
export const NUMEROLOGY_STAGES_GENERAL = [
  "num.calculatingNumber",
  "num.meansForYou",
  "num.writingReading",
];

export function numerologyStages(focus: string) {
  return NUMEROLOGY_STAGES[focus] || NUMEROLOGY_STAGES_GENERAL;
}
